"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChildGenderEnum = exports.Children = void 0;
var tslib_1 = require("tslib");
var quota_mapper_constants_1 = require("../quota-mapper/quota-mapper.constants");
var child_1 = require("../child/child");
var util_1 = require("../../shared/util");
/**
 * Extension class mapper for new child age gender qualification.
 * A instance of this class represent a group of child, its age range, genders and
 * the new condition code that represents them.
 * This class use an Child array to determine children group age, gender and age.
 */
var Children = /** @class */ (function () {
    /**
     * Create a new Child group from an array of Child
     */
    function Children(_children) {
        this._children = _children;
    }
    /**
     * Create a new Child group from criterias
     * @param {boolean} isBaby - true for baby ages, meaning months from 1 to 11.
     * false for child ages, meaning years from 1 to 17.
     * @param {ChildGenderEnum | string | boolean} genderOrIsBoy - child gender: boy, girl or both
     * If boolean: true for boy or false for girl.
     * If string: values from ChildGenderEnum.
     * @param {number} ageFrom - "from" value of age range
     * @param {number} ageTo - "to" value of age range
     * @returns a new Children instance
     */
    Children.create = function (isBaby, genderOrIsBoy, ageFrom, ageTo) {
        var ageFromValidated = this._validateAgeFrom(ageFrom);
        var gender = this._parseGender(genderOrIsBoy);
        var ageRange = ageTo - ageFromValidated;
        var children = [];
        for (var i = 0; i <= ageRange; i++) {
            if (gender === ChildGenderEnum.both) {
                children.push(child_1.Child.create(isBaby, true, ageFromValidated + i), child_1.Child.create(isBaby, false, ageFromValidated + i));
            }
            else {
                var isBoy = gender === ChildGenderEnum.boy;
                children.push(child_1.Child.create(isBaby, isBoy, ageFromValidated + i));
            }
        }
        return new Children(children);
    };
    /**
     * Validate age from if it come with 0 we need to consider it as 1
     * @param {number} ageFrom - "from" value of age range
     */
    Children._validateAgeFrom = function (ageFrom) {
        if (ageFrom === 0) {
            return 1;
        }
        else {
            return ageFrom;
        }
    };
    Children._parseGender = function (genderOrIsBoy) {
        if (typeof genderOrIsBoy === 'boolean') {
            return genderOrIsBoy ? ChildGenderEnum.boy : ChildGenderEnum.girl;
        }
        else if (typeof genderOrIsBoy === 'string') {
            var genderEnumValue = (0, util_1.getEnumByValue)(ChildGenderEnum, genderOrIsBoy);
            if (!genderEnumValue) {
                throw new Error('Gender key not found');
            }
            return genderEnumValue;
        }
        else if (!genderOrIsBoy) {
            throw new Error('Gender must be defined for children creation');
        }
        return genderOrIsBoy;
    };
    Children.prototype.toEachChild = function () {
        return this._children;
    };
    Object.defineProperty(Children.prototype, "gender", {
        get: function () {
            var isBoy = this._children.some(function (child) { return child.isBoy; });
            var isGirl = this._children.some(function (child) { return child.isBoy === false; });
            if (isBoy && isGirl) {
                return ChildGenderEnum.both;
            }
            if (isBoy) {
                return ChildGenderEnum.boy;
            }
            return ChildGenderEnum.girl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Children.prototype, "ageUnit", {
        get: function () {
            return this._children.some(function (child) { return child.isBaby; })
                ? quota_mapper_constants_1.MONTHS_CHILD_AGE_UNIT_CODE
                : quota_mapper_constants_1.YEARS_CHILD_AGE_UNIT_CODE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Children.prototype, "age", {
        get: function () {
            var ages = this._children.map(function (_a) {
                var age = _a.age;
                return Number(age);
            });
            var from = Math.min.apply(Math, tslib_1.__spreadArray([], tslib_1.__read(ages), false));
            var to = Math.max.apply(Math, tslib_1.__spreadArray([], tslib_1.__read(ages), false));
            return { from: from, to: to };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Children.prototype, "noChildren", {
        get: function () {
            return this._children.some(function (child) { return child.noChildren; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Children.prototype, "description", {
        get: function () {
            return this.noChildren ? 'No Children' : 'Children';
        },
        enumerable: false,
        configurable: true
    });
    return Children;
}());
exports.Children = Children;
var ChildGenderEnum;
(function (ChildGenderEnum) {
    ChildGenderEnum["boy"] = "111";
    ChildGenderEnum["girl"] = "112";
    ChildGenderEnum["both"] = "both";
})(ChildGenderEnum || (exports.ChildGenderEnum = ChildGenderEnum = {}));
